import { WindowService } from './../../services/window.service';
import { BountyService } from 'src/app/services/bounty.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-stats',
  templateUrl: './stats.component.html',
  styleUrls: ['./stats.component.scss'],
})
export class StatsComponent implements OnInit {
  public fetching = true;
  public topPlayers: any;
  public topCreators: any;
  public bountiesCount: number;
  public bountiesPaidCount: number;
  public usersCount: number;
  public claimsCount: number;
  public commentsCount: number;
  public totalPaid: number;

  constructor(
    private bountyService: BountyService,
    private windowService: WindowService,
  ) { }

  ngOnInit() {
    // Get initial pre-rendered data from window object
    const preRenderedData = this.windowService.appData;

    if (preRenderedData) {
      this.mapDataToState(preRenderedData);
    } else {
      this.fetchData();
    }
  }

  private mapDataToState({
    topPlayers,
    topCreators,
    bountiesCount,
    bountiesPaidCount,
    usersCount,
    claimsCount,
    commentsCount,
    totalPaid,
  }) {
    this.topPlayers = topPlayers;
    this.topCreators = topCreators;
    this.bountiesCount = bountiesCount;
    this.bountiesPaidCount = bountiesPaidCount;
    this.usersCount = usersCount;
    this.claimsCount = claimsCount;
    this.commentsCount = commentsCount;
    this.totalPaid = totalPaid;

    this.fetching = false;
  }

  async fetchData() {
    this.fetching = true;

    const data: any = await this.bountyService.getStats();

    this.mapDataToState(data);
  }
}
